export const AccountUsersActionTypes = {
    ACCOUNT_USERS_LIST : 'ACCOUNT_USERS_LIST',
    USER_GROUPS_LIST : 'USER_GROUPS_LIST',
    ADD_USER_STATUS : 'ADD_USER_STATUS',
    EDIT_USER_STATUS:'EDIT_USER_STATUS',
    DELETE_USER_STATUS:'DELETE_USER_STATUS',
    AVAILABLE_GROUPS:'AVAILABLE_GROUPS',
    CURRENTUSER: 'CURRENTUSER'
}